import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

export const defaultNS = "melco-common";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "es", "fr", "it", "nl", "pt", "de"],
    fallbackLng: "en",
    ns: ["melco-common"],
    defaultNS: "melco-common",
    debug: false,
    backend: {
      loadPath: "/translations/{{ns}}/{{lng}}.json",
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: {
      order: ["path", "navigator"],
      lookupFromPathIndex: 2,  // <-- in url language is the 3rd segment
    },
    returnNull: false,
  });

export default i18n; 
